import {Box, BoxProps, Grid, Typography} from '@material-ui/core';
import Image from 'material-ui-image';
import React from 'react';
import {StudioTooltip} from '../../../base-components/StudioTooltip';
import {Skeleton} from '../../Skeleton';
import './ImageCardHorizontal.scss';

export type ImageCardHorizontalProps = BoxProps & {
  className?: string;
  title?: string;
  image: string;
  width: number;
  height: number;
  detailComponent?: React.ReactNode;
};

export const ImageCardHorizontal = ({
  className,
  title,
  image,
  width,
  height,
  detailComponent,
  ...rest
}: ImageCardHorizontalProps) => {
  return (
    <Box className={className} {...rest}>
      <Box className="image-card-horizontal_container">
        {!image ? (
          <Skeleton variant="rect" style={{width, height, marginTop: '8px'}} />
        ) : (
          <Image
            className="image-card-horizontal_image"
            src={image!}
            imageStyle={{width, height}}
            loading={<Skeleton variant="rect" style={{width, height}} />}
          />
        )}
        {title && (
          <StudioTooltip
            title={title}
            PopperProps={{popperOptions: {positionFixed: true}}}
          >
            <Typography
              className="image-card-horizontal_text"
              variant="caption"
              color="textSecondary"
              component="div"
              align="center"
              noWrap
            >
              {title}
            </Typography>
          </StudioTooltip>
        )}
      </Box>
      <Box className="image-card-horizontal_content">
        {/* {title && (
          <div className="image-card-horizontal_title" title={title}>
            {title}
          </div>
        )} */}
        {detailComponent && (
          <Grid
            container
            spacing={1}
            direction="column"
            className="image-card-horizontal_detail_content"
          >
            <Grid item>{detailComponent}</Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};
